// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #1565c0;
  --accent-color: #42a5f5;
  --border-radius: 14px;
  --box-shadow: 0 16px 60px rgba(0, 0, 0, 0.25);
}

.SingleQuestion_overlay__qKCCM {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1400;
}

.SingleQuestion_container__0gp8L {
  position: fixed;
  top: 110px;
  right: 20px;
  width: min(680px, 100vw - 24px);
  max-height: min(80vh, 720px);
  background: #fff;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto;
}
.SingleQuestion_container__0gp8L.SingleQuestion_dragging__OUAjv {
  transition: none;
  cursor: move;
}

.SingleQuestion_header__ZdMBW {
  padding: 14px 16px;
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.SingleQuestion_headerLeft__jeF4u {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.SingleQuestion_badge__zdGvF {
  font-size: 12px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  flex-shrink: 0;
}

.SingleQuestion_prefixBadge__0lrkI {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 900;
  color: rgba(13, 71, 161, 0.92);
  background: rgba(21, 101, 192, 0.08);
  border: 1px solid rgba(21, 101, 192, 0.2);
  padding: 5px 10px;
  border-radius: 999px;
  margin-bottom: 10px;
}

.SingleQuestion_title__wA5cZ {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SingleQuestion_questionTitle__RlwlJ {
  padding: 14px 16px 6px 16px;
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.SingleQuestion_closeButton__nVt9d {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  transition: transform 0.15s ease, background 0.2s ease;
}
.SingleQuestion_closeButton__nVt9d:hover {
  background: rgba(255, 255, 255, 0.22);
  transform: scale(1.05);
}

.SingleQuestion_content__GHPCr {
  padding: 16px;
  overflow: auto;
}

.SingleQuestion_historySection__gEH4e {
  margin-bottom: 14px;
}

.SingleQuestion_historySectionTitle__vo5gm {
  font-size: 12px;
  font-weight: 900;
  color: rgba(15, 23, 42, 0.75);
  margin-bottom: 10px;
}

.SingleQuestion_historyList__oKHs8 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.SingleQuestion_historyItem__mlvB8 {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  padding: 12px 12px;
}

.SingleQuestion_historyTitle__15Z8w {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.45;
  margin-bottom: 8px;
  white-space: pre-wrap;
  word-break: break-word;
}

.SingleQuestion_historyAnswerLine__c3Mon {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.SingleQuestion_historyAnswerLabel__DAV7V {
  font-size: 12px;
  font-weight: 800;
  color: rgba(15, 23, 42, 0.65);
}

.SingleQuestion_historyAnswerValue__YFd5Y {
  font-size: 12px;
  font-weight: 900;
  color: #0d47a1;
  background: rgba(21, 101, 192, 0.08);
  border: 1px solid rgba(21, 101, 192, 0.18);
  padding: 3px 8px;
  border-radius: 999px;
}

.SingleQuestion_historyAnswerText__ASWvC {
  font-size: 13px;
  line-height: 1.45;
  color: rgba(17, 24, 39, 0.9);
  white-space: pre-wrap;
}

.SingleQuestion_currentSection__kf-Dv {
  border-top: 1px dashed rgba(148, 163, 184, 0.7);
  padding-top: 14px;
}

.SingleQuestion_waitingBox__aYBRP {
  border: 1px dashed rgba(21, 101, 192, 0.35);
  background: rgba(21, 101, 192, 0.04);
  border-radius: 12px;
  padding: 14px 12px;
}

.SingleQuestion_endedBox__BsD0n {
  border: 1px solid rgba(76, 175, 80, 0.35);
  background: rgba(76, 175, 80, 0.06);
  border-radius: 12px;
  padding: 14px 12px;
}

.SingleQuestion_endedTitle__B0vPH {
  font-size: 14px;
  font-weight: 900;
  color: #1b5e20;
  margin-bottom: 6px;
}

.SingleQuestion_endedSub__KXz0u {
  font-size: 13px;
  font-weight: 700;
  color: rgba(27, 94, 32, 0.8);
  line-height: 1.45;
}

.SingleQuestion_disabledOption__CSm60 {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.SingleQuestion_currentSectionTitle__jOmMQ {
  font-size: 12px;
  font-weight: 900;
  color: rgba(15, 23, 42, 0.75);
  margin-bottom: 10px;
}

.SingleQuestion_options__DOa8D {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.SingleQuestion_optionButton__RbzeW {
  width: 100%;
  text-align: left;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 12px;
  padding: 14px 14px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  transition: all 0.15s ease;
}
.SingleQuestion_optionButton__RbzeW:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}
.SingleQuestion_optionButton__RbzeW.SingleQuestion_selected__ouWvL {
  border-color: rgba(21, 101, 192, 0.55);
  background: rgba(21, 101, 192, 0.08);
}

.SingleQuestion_optionLetter__GqRQn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(66, 165, 245, 0.14);
  border: 1px solid rgba(66, 165, 245, 0.26);
  color: #0d47a1;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.SingleQuestion_optionText__bFy6Y {
  color: #111827;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
}

.SingleQuestion_footer__e32xx {
  padding: 14px 16px;
  border-top: 1px solid #eef2f7;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
}

.SingleQuestion_cancelButton__s6RU- {
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #111827;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
}
.SingleQuestion_cancelButton__s6RU-:hover {
  background: #f8fafc;
}

.SingleQuestion_submitButton__\\+TVVp {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
  border: none;
  color: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.2s ease;
}
.SingleQuestion_submitButton__\\+TVVp:hover:not(:disabled) {
  transform: translateY(-1px);
}
.SingleQuestion_submitButton__\\+TVVp.SingleQuestion_disabled__Gjfnx, .SingleQuestion_submitButton__\\+TVVp:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .SingleQuestion_container__0gp8L {
    width: calc(100vw - 16px);
    max-height: 86vh;
  }
  .SingleQuestion_title__wA5cZ {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SingleQuestion/index.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6CAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAGA,uBAAA;EACA,oBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAFF;;AAKA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EAEA,+BAAA;EACA,4BAAA;EACA,gBAAA;EACA,mCAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;AAHF;AAKE;EACE,gBAAA;EACA,YAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,oCAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,qCAAA;EACA,2CAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,sDAAA;AAJF;AAME;EACE,qCAAA;EACA,sBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALF;;AAQA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,oBAAA;AALF;;AAQA;EACE,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;AALF;;AAQA;EACE,+CAAA;EACA,iBAAA;AALF;;AAQA;EACE,2CAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,yCAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALF;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,0BAAA;AALF;AAOE;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;AALJ;AAQE;EACE,sCAAA;EACA,oCAAA;AANJ;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAPF;;AAUA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,6DAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AARF;AAUE;EACE,2BAAA;AARJ;AAWE;EAEE,YAAA;EACA,mBAAA;EACA,eAAA;AAVJ;;AAcA;EACE;IACE,yBAAA;IACA,gBAAA;EAXF;EAcA;IACE,eAAA;EAZF;AACF","sourcesContent":[":root {\n  --primary-color: #1565c0;\n  --accent-color: #42a5f5;\n  --border-radius: 14px;\n  --box-shadow: 0 16px 60px rgba(0, 0, 0, 0.25);\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  // 与 ChatDialog 一致：不使用暗色遮罩，同时允许操作穿透到背后页面\n  background: transparent;\n  pointer-events: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1400;\n}\n\n.container {\n  position: fixed;\n  top: 110px;\n  right: 20px;\n\n  width: min(680px, calc(100vw - 24px));\n  max-height: min(80vh, 720px);\n  background: #fff;\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  pointer-events: auto;\n\n  &.dragging {\n    transition: none;\n    cursor: move;\n  }\n}\n\n.header {\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.badge {\n  font-size: 12px;\n  font-weight: 800;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  flex-shrink: 0;\n}\n\n.prefixBadge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 900;\n  color: rgba(13, 71, 161, 0.92);\n  background: rgba(21, 101, 192, 0.08);\n  border: 1px solid rgba(21, 101, 192, 0.2);\n  padding: 5px 10px;\n  border-radius: 999px;\n  margin-bottom: 10px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.questionTitle {\n  padding: 14px 16px 6px 16px;\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.closeButton {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  color: #fff;\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  transition: transform 0.15s ease, background 0.2s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.22);\n    transform: scale(1.05);\n  }\n}\n\n.content {\n  padding: 16px;\n  overflow: auto;\n}\n\n.historySection {\n  margin-bottom: 14px;\n}\n\n.historySectionTitle {\n  font-size: 12px;\n  font-weight: 900;\n  color: rgba(15, 23, 42, 0.75);\n  margin-bottom: 10px;\n}\n\n.historyList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.historyItem {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  border-radius: 12px;\n  padding: 12px 12px;\n}\n\n.historyTitle {\n  font-size: 13px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.45;\n  margin-bottom: 8px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.historyAnswerLine {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.historyAnswerLabel {\n  font-size: 12px;\n  font-weight: 800;\n  color: rgba(15, 23, 42, 0.65);\n}\n\n.historyAnswerValue {\n  font-size: 12px;\n  font-weight: 900;\n  color: #0d47a1;\n  background: rgba(21, 101, 192, 0.08);\n  border: 1px solid rgba(21, 101, 192, 0.18);\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.historyAnswerText {\n  font-size: 13px;\n  line-height: 1.45;\n  color: rgba(17, 24, 39, 0.9);\n  white-space: pre-wrap;\n}\n\n.currentSection {\n  border-top: 1px dashed rgba(148, 163, 184, 0.7);\n  padding-top: 14px;\n}\n\n.waitingBox {\n  border: 1px dashed rgba(21, 101, 192, 0.35);\n  background: rgba(21, 101, 192, 0.04);\n  border-radius: 12px;\n  padding: 14px 12px;\n}\n\n.endedBox {\n  border: 1px solid rgba(76, 175, 80, 0.35);\n  background: rgba(76, 175, 80, 0.06);\n  border-radius: 12px;\n  padding: 14px 12px;\n}\n\n.endedTitle {\n  font-size: 14px;\n  font-weight: 900;\n  color: #1b5e20;\n  margin-bottom: 6px;\n}\n\n.endedSub {\n  font-size: 13px;\n  font-weight: 700;\n  color: rgba(27, 94, 32, 0.8);\n  line-height: 1.45;\n}\n\n.disabledOption {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.currentSectionTitle {\n  font-size: 12px;\n  font-weight: 900;\n  color: rgba(15, 23, 42, 0.75);\n  margin-bottom: 10px;\n}\n\n.options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.optionButton {\n  width: 100%;\n  text-align: left;\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 14px 14px;\n  cursor: pointer;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: #f1f5f9;\n    border-color: #cbd5e1;\n    transform: translateY(-1px);\n  }\n\n  &.selected {\n    border-color: rgba(21, 101, 192, 0.55);\n    background: rgba(21, 101, 192, 0.08);\n  }\n}\n\n.optionLetter {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: rgba(66, 165, 245, 0.14);\n  border: 1px solid rgba(66, 165, 245, 0.26);\n  color: #0d47a1;\n  font-weight: 900;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.optionText {\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.footer {\n  padding: 14px 16px;\n  border-top: 1px solid #eef2f7;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #fff;\n}\n\n.cancelButton {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  color: #111827;\n  border-radius: 10px;\n  padding: 10px 14px;\n  cursor: pointer;\n\n  &:hover {\n    background: #f8fafc;\n  }\n}\n\n.submitButton {\n  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);\n  border: none;\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: transform 0.15s ease, opacity 0.2s ease;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-1px);\n  }\n\n  &.disabled,\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    width: calc(100vw - 16px);\n    max-height: 86vh;\n  }\n\n  .title {\n    font-size: 13px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `SingleQuestion_overlay__qKCCM`,
	"container": `SingleQuestion_container__0gp8L`,
	"dragging": `SingleQuestion_dragging__OUAjv`,
	"header": `SingleQuestion_header__ZdMBW`,
	"headerLeft": `SingleQuestion_headerLeft__jeF4u`,
	"badge": `SingleQuestion_badge__zdGvF`,
	"prefixBadge": `SingleQuestion_prefixBadge__0lrkI`,
	"title": `SingleQuestion_title__wA5cZ`,
	"questionTitle": `SingleQuestion_questionTitle__RlwlJ`,
	"closeButton": `SingleQuestion_closeButton__nVt9d`,
	"content": `SingleQuestion_content__GHPCr`,
	"historySection": `SingleQuestion_historySection__gEH4e`,
	"historySectionTitle": `SingleQuestion_historySectionTitle__vo5gm`,
	"historyList": `SingleQuestion_historyList__oKHs8`,
	"historyItem": `SingleQuestion_historyItem__mlvB8`,
	"historyTitle": `SingleQuestion_historyTitle__15Z8w`,
	"historyAnswerLine": `SingleQuestion_historyAnswerLine__c3Mon`,
	"historyAnswerLabel": `SingleQuestion_historyAnswerLabel__DAV7V`,
	"historyAnswerValue": `SingleQuestion_historyAnswerValue__YFd5Y`,
	"historyAnswerText": `SingleQuestion_historyAnswerText__ASWvC`,
	"currentSection": `SingleQuestion_currentSection__kf-Dv`,
	"waitingBox": `SingleQuestion_waitingBox__aYBRP`,
	"endedBox": `SingleQuestion_endedBox__BsD0n`,
	"endedTitle": `SingleQuestion_endedTitle__B0vPH`,
	"endedSub": `SingleQuestion_endedSub__KXz0u`,
	"disabledOption": `SingleQuestion_disabledOption__CSm60`,
	"currentSectionTitle": `SingleQuestion_currentSectionTitle__jOmMQ`,
	"options": `SingleQuestion_options__DOa8D`,
	"optionButton": `SingleQuestion_optionButton__RbzeW`,
	"selected": `SingleQuestion_selected__ouWvL`,
	"optionLetter": `SingleQuestion_optionLetter__GqRQn`,
	"optionText": `SingleQuestion_optionText__bFy6Y`,
	"footer": `SingleQuestion_footer__e32xx`,
	"cancelButton": `SingleQuestion_cancelButton__s6RU-`,
	"submitButton": `SingleQuestion_submitButton__+TVVp`,
	"disabled": `SingleQuestion_disabled__Gjfnx`
};
export default ___CSS_LOADER_EXPORT___;
